import { render, staticRenderFns } from "./Gdp.vue?vue&type=template&id=2081b1fa&scoped=true&"
import script from "./Gdp.vue?vue&type=script&lang=js&"
export * from "./Gdp.vue?vue&type=script&lang=js&"
import style0 from "./Gdp.vue?vue&type=style&index=0&id=2081b1fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2081b1fa",
  null
  
)

export default component.exports